export default __webpack_public_path__ + "static/media/girl.a0217da8.ogg";